"use client";
import React from 'react';
import { ReportFilterType } from '../types';
import { Select, FormGroup } from '@develos/next-components';
import { useTranslations } from '@develos/next-library';
import { aggregationTypesOptions, reportFormatsOptions, reportTypesOptions } from '../constants';

type Props = {
  filters: ReportFilterType,
  setFilters: React.Dispatch<React.SetStateAction<ReportFilterType>>,
}

const ReportConfigContainer = ({filters, setFilters}: Props) => {
  const { translate } = useTranslations();
  return (
    <>
      <div className="rm-relative md:rm-col-span-6 lg:rm-col-span-4 xl:rm-col-span-3">  
        <FormGroup label={translate('Typ raportu')}>
          <Select
            options={reportTypesOptions}
            value={filters.selectedReportType as number}
            handleChange={(e, value) => setFilters({
              ...filters, 
              selectedReportType: value as number
            })} 
          />
        </FormGroup>
      </div>
      <div className="rm-relative md:rm-col-span-6 lg:rm-col-span-4 xl:rm-col-span-3">  
        <FormGroup label={translate('Format raportu')}>
          <Select
            options={reportFormatsOptions}
            value={filters.selectedReportFormat}
            handleChange={(e, value) => setFilters({
              ...filters, 
              selectedReportFormat: value as number
            })} 
          />
        </FormGroup>
      </div>
      <div className="rm-relative md:rm-col-span-6 lg:rm-col-span-4 xl:rm-col-span-3">  
        <FormGroup label={translate('Zagregowany')}>
          <Select
            options={aggregationTypesOptions}
            value={filters.selectedAggregationType as number}
            handleChange={(e, value) => setFilters({
              ...filters, 
              selectedAggregationType: value as number
            })} 
          />
        </FormGroup>
      </div>
    </>
  );
};

export default ReportConfigContainer;